import type { GameSession, SessionSnapshot } from '../../game/session';
import { sideName } from '../../game/sideName';
import type { TabletItem } from './tablet';

/**
 * A draw offered to a side a person here answers for (D-46): the action tablet asks them, as it
 * asks for a muster, with the same session method the screen's buttons use. Null when no offer
 * waits on this device.
 */
export function drawItems(
  snapshot: SessionSnapshot,
  session: Pick<GameSession, 'answerDraw'>,
  /** The tablet text size, `LARGE_TEXT` or 1. */
  k = 1,
): TabletItem[] | null {
  const draw = snapshot.draw;
  if (!draw?.asking) return null;
  return [
    {
      kind: 'text',
      text: `DRAW OFFERED · ${sideName(snapshot, draw.asking)}`,
      x: 520,
      y: 95,
      size: 40 * k,
      align: 'center',
      maxWidth: 860,
    },
    {
      kind: 'text',
      text: `${sideName(snapshot, draw.from)} offers a draw.`,
      x: 100,
      y: 175,
      size: 34 * k,
      maxWidth: 840,
    },
    {
      kind: 'gem',
      id: 'draw-accept',
      rect: { x: 90, y: 240, w: 860, h: 68 },
      gem: 'emerald',
      label: 'Accept the draw',
      fontSize: 34 * k,
      enabled: true,
      onTap: () => session.answerDraw(true),
    },
    {
      kind: 'gem',
      id: 'draw-decline',
      rect: { x: 90, y: 320, w: 860, h: 68 },
      gem: 'ruby',
      label: 'Decline and play on',
      fontSize: 34 * k,
      enabled: true,
      onTap: () => session.answerDraw(false),
    },
  ];
}
